import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PrivateRoute from 'routing/PrivateRoute';
import PropTypes from 'prop-types';
import './ExternalEmptyLayout.scss';
import Header from 'components/Navigation/Sidebar/Header';
import { useMediaQuery } from '@mui/material';

const ExternalEmptyLayout = (props) => {
    const { component: Component, auth, serverNotifications, ...rest } = props;
    const [toastType, setToastType] = useState(null);
    const defaultOpen = useMediaQuery('(min-width: 66.625em)', { noSsr: true });
    const [open, setOpen] = useState(defaultOpen);

    return (
        <>
            <PrivateRoute
                {...rest}
                routeType={rest.sentralUnsafeRoute ? 'sentral' : 'guest'}
                isAuthenticated={auth.isAuthenticated}
                render={(componentProps) => {
                    return (
                        <div className='app-wrapper'>
                            <Header open={open} setOpen={setOpen} externalLayout />
                            <div className='content-page full-width'>
                                <Component {...componentProps} />
                            </div>
                        </div>
                    );
                }}
            />
        </>
    );
};

ExternalEmptyLayout.propTypes = {
    component: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    serverNotifications: state.ui.serverNotifications,
});

export default connect(mapStateToProps, {})(ExternalEmptyLayout);
